import { InitiativeIcon } from 'assets/assetsV1/iconComponents';
import NoInitiatives from 'assets/assetsV1/illustrations/newIllustrations/noInitiatives.svg';

import { SkeletonLoader } from 'uiToolkitV1/SkeletonLoader';

import { EmptySummaryCard } from '../../EmptyCard/EmptySummaryCard';
import { ProfileSummaryCardTemplate } from '../ProfileSummaryCardTemplate';
import { InitiativesAgGrid } from './components/InitiativesAgGrid';
import { useInitiativeTableDataQuery } from './hooks';

interface Props {
  employeeId: string;
}

const InitiativesProfileSummaryAgGrid = ({ employeeId }: Props) => {
  //   @ts-ignore
  const { data, isLoading } = useInitiativeTableDataQuery({
    attributeFilter: {
      filterConditions: [
        {
          type: 'NAME',
          operatorType: 'IN',
          data: [employeeId],
        },
        {
          type: 'TYPE',
          operatorType: 'IN',
          data: ['TASK'],
        },
      ],
    },
    employeeId,
    pageType: 'PROFILE_PAGE',
  });

  const firstFiveInitiatives = data?.computedData?.slice(0, 5) ?? [];

  if (isLoading) {
    return (
      // @ts-ignore
      <ProfileSummaryCardTemplate showViewAllButton={false} Icon={InitiativeIcon} heading="Initiatives">
        <div style={{ marginTop: '16px' }}>
          <SkeletonLoader />
        </div>
      </ProfileSummaryCardTemplate>
    );
  }

  if (!data?.computedData?.length) {
    return (
      <EmptySummaryCard
        Icon={InitiativeIcon}
        heading="Initiatives"
        description="They haven't created any initiatives yet"
        illustrationSrc={NoInitiatives}
      />
    );
  }

  return (
    // @ts-ignore
    <ProfileSummaryCardTemplate
      Icon={InitiativeIcon}
      heading="Initiatives"
      showViewAllButton={false}
      onClickViewAll={() => {}}
    >
      <InitiativesAgGrid tableData={firstFiveInitiatives} pageType="Profile Page" />
    </ProfileSummaryCardTemplate>
  );
};

export { InitiativesProfileSummaryAgGrid };
